/** Tiny classnames joiner. Falsy values are dropped, no dependency needed. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
